import  {   Component   } from "@angular/core";
import  {   CqForm      } from "src/app/parents/cq-form";

@Component({
    selector    :   'cq-form' ,
    templateUrl :   './cq-form.component.html',
    styleUrls   :   ['./cq-form.component.scss'],
    inputs      :   [   
                    'appearance'
                  , 'label'
                  , 'values'
                  , 'disabled'
                  , 'multiple'
                  , 'all'
                  , 'help'
                  , 'helpIcon'
                  , 'formCtrl'
                  , 'validators'
                  , 'displayFn'
    ]
})
export class CqFormComponent extends CqForm { }
